export default "__VITE_ASSET__CdsyGJmR__"